import { makeStyles } from '../../../../styles';
export const useStyles = makeStyles((theme) => {
    return {
        container: {
            display: 'block',
        },
        progress: {
            height: '8px',
            borderRadius: 8,
            backgroundColor: theme.colors.gray[0],
            '& .MuiLinearProgress-dashed': {
                backgroundSize: '6px 6px',
            },
            '& .MuiLinearProgress-bar': {
                borderRadius: 8,
            },
        },
    };
});
//# sourceMappingURL=LinearProgress.styles.js.map